// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

export default function InputLabel(theme) {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.vars.palette.grey[700],
          fontWeight: 600,
          display: 'block',
          transform: 'none',
          marginBottom: 6,
          lineHeight: 1.2
        },
        outlined: {
          position: 'static',
          transform: 'none',
          marginBottom: 6,
          '&.MuiInputLabel-sizeSmall': {
            lineHeight: '1em'
          },
          '&.MuiInputLabel-shrink': {
            transform: 'none',
            marginBottom: 8,
            background: 'transparent',
            padding: 0,
            top: 0
          }
        }
      }
    }
  };
}
